import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useHistory, Prompt } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { Form, Formik, FormikProps } from 'formik';
import axios from 'axios';
import { snakeCase } from 'lodash';
import { HeaderContainer, HeaderWrapper } from '../CampaignDetails/CampaignDetails.styles';
import { Stepper } from '../components/Stepper';
import { validationSchema } from './utils/validationSchema';
import { campaignInitialValues, campaignSteps, mapKeysDeepLodash } from './utils/utils';
import { useAuth } from '../context/auth';
import {
  NavigationWrapper,
  StyledContainer,
  ButtonNext,
  ButtonPrevious,
  ButtonDraft
} from './CreateCampign.styles';
import {
  BasicInformation,
  Content,
  Location,
  Products,
  Duration,
} from './Sections';

export const CreateCampaign = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [submitType, setSubmitType] = useState('');
  const [initialValues, setInitialValues] = useState(campaignInitialValues);
  const [blockRedirect, setBlockRedirect] = useState(false);
  const { authToken, user } = useAuth();
  const history = useHistory();
  const handleNext = (values:any) => {
    if(activeStep < validationSchema.length - 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      window.scrollTo(0, 0);
      setBlockRedirect(true);
    }  
    if(activeStep === validationSchema.length - 1) {
      setBlockRedirect(false);
      const mappedValues = mapKeysDeepLodash(values, (v:any, k:any) => snakeCase(k));
      axios.post(`${process.env.REACT_APP_BASE_URL}/api/campaign/campaign/`, {...mappedValues, submit_type: submitType}, {headers: { DTOKEN: `${authToken}`}}).then(res => {
        const { id } = res.data;
        sessionStorage.removeItem('publicUrl');
        sessionStorage.removeItem('uniqueTitle');
        sessionStorage.removeItem('disabledTypeChange');
        history.push(`${process.env.REACT_APP_INTERNAL_URL}campaign-details/${id}`);
      });
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  useEffect(() => {
    window.scrollTo(0 ,0);
    // @ts-ignore
    if(history.location.state && history.location.state.initialDuplicateValues) {
      // @ts-ignore
      setInitialValues(history.location.state.initialDuplicateValues);
      setBlockRedirect(true);
    }
    else {
      sessionStorage.removeItem('disabledTypeChange');
    }
  }, []);
  const checkFiles = (values: any) => {
    const data = values.values.content;
    const adType = values.values.basicInformation.adType;
    if (adType === 'S' || adType === 'P' || adType === 'V') {
      if (!data.mediaFile) {
        return true;
      }
    }
    if (adType === 'B') {
      if (!data.mobileFile || !data.desktopFile) {
        return true;
      }
    }
    return false;
  }
  const checkFields = (e: {title: string, description: string, adType: string }) => {
    if (activeStep === 0) {
      return !!(e.title || e.description || e.adType);
    }
    return false;
  }
  return (
    <>
      <HeaderWrapper>
        <HeaderContainer>
          <h1>New Campaign</h1>
        </HeaderContainer>
      </HeaderWrapper>
      <StyledContainer>
        <Grid container>
          <Grid item xs={12} sm={4}>
            <Stepper current={activeStep} steps={campaignSteps} />
          </Grid>
          <Grid item xs={12} sm={8}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema[activeStep]}
              onSubmit={handleNext}
              enableReinitialize
            >
              {(props: FormikProps<any>) => (
                <Form id="create-campaign">
                  <Prompt when={blockRedirect || checkFields(props.values.basicInformation)} message={'Are you sure?'} />
                  {activeStep === 0 && <BasicInformation {...props} />}
                  {activeStep === 1 && <Content {...props} />}
                  {activeStep === 2 && <Location {...props} />}
                  {activeStep === 3 && <Products {...props} />}
                  {activeStep === 4 && <Duration {...props} />}
                  <NavigationWrapper activeStep={activeStep}>
                    <ButtonPrevious type="button" onClick={handleBack} disabled={activeStep === 0} first={activeStep === 0}><ArrowBack />{(!isMobile || (isMobile && activeStep == 4)) && 'Previous step'}</ButtonPrevious>
                    {activeStep === 4 && <ButtonDraft type="button" onClick={async () => {
                      await setSubmitType('draft');
                      await props.handleSubmit()
                    }}>Save as draft</ButtonDraft>}
                    {user && (user.isAdmin && activeStep !== 4) &&
                      <ButtonNext 
                        type="button" 
                        onClick={async () => {
                          await setSubmitType('send_for_approval');
                          await props.handleSubmit()
                        }}
                        disabled={(activeStep === 0 && sessionStorage.getItem('uniqueTitle') === 'false') || (activeStep === 1 && checkFiles(props))}
                      >
                        {checkFiles(props)}
                        Next
                      </ButtonNext>
                    }
                    {(user && !user.isAdmin) &&
                      <ButtonNext 
                        type="button" 
                        onClick={async () => {
                          await setSubmitType('send_for_approval');
                          await props.handleSubmit()
                        }}
                        disabled={(activeStep === 0 && sessionStorage.getItem('uniqueTitle') === 'false') || (activeStep === 1 && checkFiles(props))}
                      >
                        {checkFiles(props)}
                        {activeStep === 4
                          ? 'Complete & send for approval'
                          : 'Next'
                        }
                      </ButtonNext>
                    }
                  </NavigationWrapper>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </StyledContainer>
    </>
  );
};
